import { MdOutlineAdd } from 'react-icons/md';
import { Button } from '../../../../../components/button/button';
import { Page } from '../../../../../components/page/page';
import { Select } from '../../../../../components/select/select';
import { HasAccess } from '../../../../../features/has-access/has-access';
import { MenuInformerSlider } from './menu-informer-slider/menu-informer-slider';
import { MenuInformerMenuTable } from './menu-informer-table/menu-informer-table';
import s from './menu-informer.module.css';
import { useMenuInformer } from './use-menu-informer';

export const MenuInformer = () => {
  const {
    t,
    menuList,
    handleCreateMenu,
    branches,
    selectedBranch,
    handleSelectBranch,
    branchId,
    selectedMenu,
  } = useMenuInformer();

  return (
    <Page className={s.page}>
      <div className={s.header}>
        <Select
          placeholder={t('Все')}
          className={s.select}
          options={branches}
          onSelect={handleSelectBranch}
          value={selectedBranch}
          prefix={t('Филиал') + ': '}
        />
        {branchId && (
          <HasAccess service="menu" permissions={['write']}>
            <Button onClick={handleCreateMenu}>
              <MdOutlineAdd />
              {t('Создать меню')}
            </Button>
          </HasAccess>
        )}
      </div>
      <MenuInformerSlider />

      {!menuList?.length && (
        <div className={s.empty}>
          <div>
            <span>{t('У вас еще нет меню, пожалуйста')}</span>
            <br />
            <span>{t('создайте новое')}</span>
          </div>
        </div>
      )}

      {!!menuList?.length && !selectedMenu && (
        <div className={s.empty}>
          <span>{t('Выберите меню')}</span>
        </div>
      )}

      {selectedMenu && <MenuInformerMenuTable />}
    </Page>
  );
};
